/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type models_Childcare = {
    address_id?: string;
    /**
     * Canton is the Swiss canton code where this childcare is located (2-letter uppercase)
     * pattern: ^[A-Z]{2}$
     */
    canton?: models_Childcare.canton;
    created_at?: string;
    created_by?: string;
    deleted_at?: string;
    id?: string;
    logo_url?: string;
    name?: string;
    org_id?: string;
    /**
     * Phone is the public phone number of this location, shown to parents as a call button.
     */
    phone?: string;
    status?: string;
    updated_at?: string;
    updated_by?: string;
};
export namespace models_Childcare {
    /**
     * Canton is the Swiss canton code where this childcare is located (2-letter uppercase)
     * pattern: ^[A-Z]{2}$
     */
    export enum canton {
        AG = 'AG',
        AI = 'AI',
        AR = 'AR',
        BE = 'BE',
        BL = 'BL',
        BS = 'BS',
        FR = 'FR',
        GE = 'GE',
        GL = 'GL',
        GR = 'GR',
        JU = 'JU',
        LU = 'LU',
        NE = 'NE',
        NW = 'NW',
        OW = 'OW',
        SG = 'SG',
        SH = 'SH',
        SO = 'SO',
        SZ = 'SZ',
        TG = 'TG',
        TI = 'TI',
        UR = 'UR',
        VD = 'VD',
        VS = 'VS',
        ZG = 'ZG',
        ZH = 'ZH',
    }
}

